<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12">
        <b-table
          responsive
          hover
          show-empty
          perPage="3"
          ref="recentReqFilesTable"
          :fields="fields"
          :items="files"
          :busy="recentReqFilesLoading"
          @row-clicked="viewRequestDetails"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </template>

          <template #head()="data">
            <span class="text-capitalize">{{ data.label }}</span>
          </template>

          <template #empty>
            <h6 class="text-center">Empty request file/s data</h6>
          </template>

          <template #emptyfiltered>
            <h6 class="text-center">No request file/s data found</h6>
          </template>

          <template
            #cell(name)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            {{
              data.item.file_share
                ? data.item.file_share.file.name
                : data.item.file_request.name
            }}
          </template>

          <template
            v-if="!isEmptyObj(user) && user.user_type === 'business_admin'"
            #cell(due_date)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            {{ data.item.file_request.due_date | formatDate }}
          </template>
          <template
            v-else
            #cell(file_request.due_date)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            {{ data.item.file_request.due_date | formatDate }}
          </template>

          <template
            v-if="!isEmptyObj(user) && user.user_type === 'business_admin'"
            #cell(requested_to)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            <!-- {{ data.item.requested_to.map(e => e.full_name).join(', ') }} -->
            {{ data.item.user.full_name }}
          </template>
          <template
            v-else
            #cell(file_request.user.full_name)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            {{ data.item.file_request.user.full_name }}
          </template>

          <template
            #cell(file_share.file.status)="data"
            :class="'px-0 text-center recent-req-file-action-col'"
          >
            <template v-if="data.item.file_share">
              <b-badge
                pill
                :variant="statusBadge(data.item.file_share.file.status)"
                class="badge-hovered text-capitalize"
              >
                {{ data.item.file_share.file.status }}
              </b-badge>
            </template>
            <!-- <template
              v-else-if="data.item.has_shared"
              :class="'px-0 text-center recent-req-file-action-col'"
            >
              <b-badge
                pill
                variant="danger"
                class="badge-hovered text-capitalize"
              >
                Rejected
              </b-badge>
            </template> -->
            <template
              v-else
              :class="'px-0 text-center recent-req-file-action-col'"
            >
              <b-badge
                pill
                variant="secondary"
                class="badge-hovered text-capitalize"
              >
                Not Started
              </b-badge>
            </template>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal
      centered
      v-model="delModalShow"
      id="delete-file-modal"
      title="Delete selected file?"
    >
      <p class="my-4">
        Are you sure you want to delete the selected file?
      </p>

      <template #modal-footer>
        <b-button variant="secondary" @click="cancelDelFiles()">
          No
        </b-button>
        <b-button variant="primary" @click="deleteFiles(delModalId)">
          Yes
        </b-button>
      </template>
    </b-modal>

    <b-alert
      dismissible
      fade
      class="custom-alert"
      :show="dismissCountDown"
      :variant="alertType"
      @dismissed="clearAlert"
      @dismiss-count-down="dlCountDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { isEmpty } from 'lodash'
import dayjs from 'dayjs'

export default {
  data() {
    return {
      recentReqFilesLoading: false,
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary',
      delModalShow: false,
      delModalId: 0
    }
  },

  props: {
    files: {
      type: [Object, Array],
      default: null
    }
  },

  computed: {
    ...mapGetters('home', ['homeData']),
    ...mapGetters('auth', ['user']),

    nameHeaderKey() {
      if (!this.isEmptyObj(this.user)) {
        return 'name'
      } else {
        return ''
      }
    },

    projectHeaderKey() {
      if (!this.isEmptyObj(this.user)) {
        if (this.user.user_type === 'business_admin') {
          return 'project'
        } else {
          return 'file_request.project'
        }
      } else {
        return ''
      }
    },

    dueDateHeaderKey() {
      if (!this.isEmptyObj(this.user)) {
        if (this.user.user_type === 'business_admin') {
          return 'due_date'
        } else {
          return 'file_request.due_date'
        }
      } else {
        return ''
      }
    },

    userHeaderKey() {
      if (!this.isEmptyObj(this.user)) {
        if (this.user.user_type === 'business_admin') {
          return 'requested_to'
        } else {
          return 'file_request.user.full_name'
        }
      } else {
        return ''
      }
    },

    userHeaderLabel() {
      if (!this.isEmptyObj(this.user)) {
        if (this.user.user_type === 'business_admin') {
          return 'Assigned To'
        } else {
          return 'Assigned By'
        }
      } else {
        return ''
      }
    },

    fields() {
      return [
        {
          key: this.nameHeaderKey,
          label: 'File Name',
          class: 'w-25',
          sortable: true
        },
        {
          key: this.dueDateHeaderKey,
          label: 'Due Date',
          class: 'w-25',
          sortable: true
        },
        // {
        //   key: this.projectHeaderKey,
        //   label: 'Company Requesting',
        //   class: 'w-8',
        //   sortable: true
        // },
        {
          key: this.userHeaderKey,
          label: this.userHeaderLabel,
          class: 'w-25',
          sortable: true
        },
        {
          key: 'file_share.file.status',
          label: 'Status',
          class: 'w-25',
          sortable: true
        }
      ]
    }
  },

  filters: {
    formatDate(date) {
      return dayjs(date).format('DD MMM YYYY')
    }
  },

  methods: {
    viewRequestDetails(item, i) {
      if (this.user.user_type === 'business_admin') {
        this.$router.push({
          name: 'request.view-requested-to-page',
          params: {
            id: item.file_request_id
          }
        })
      } else {
        this.$router.push({
          name: 'request.view-requested-by-page',
          params: {
            id: item.id
          }
        })
      }
    },

    async downloadFiles(item) {
      await this.$api
        .get(`download-file/${item.id}`, {
          responseType: 'blob'
        })
        .then(data => {
          this.alertMsg = 'Requested download file successful!'
          this.dismissCountDown = 5
          const name = this.user.full_name
          const filename = `${name} - ${item.name}.zip`
          const url = URL.createObjectURL(
            new Blob([data], {
              type: 'application/zip'
            })
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          setTimeout(e => {
            this.clearAlert()
          }, 5000)

          this.alertType = 'danger'
          this.alertMsg =
            'Something went wrong while requesting your requested download file!'
          this.dismissCountDown = 5
        })
    },

    async deleteFiles(id) {
      await this.$api
        .delete(`file/${id}`)
        .then(({ data }) => {
          if (data.success) {
            this.alertMsg = 'Delete file successful!'
            this.dismissCountDown = 5
            this.getRecentRequestedFiles()
            this.cancelDelFiles()
          }
        })
        .catch(e => {
          setTimeout(e => {
            this.clearAlert()
          }, 5000)

          this.alertType = 'danger'
          this.alertMsg = 'Something went wrong while deleting file!'
          this.dismissCountDown = 5
          this.cancelDelFiles()
        })
    },

    showDelFiles(id) {
      this.delModalShow = true
      this.delModalId = id
    },

    cancelDelFiles() {
      this.delModalShow = false
      this.delModalId = 0
    },

    dlCountDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },

    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },

    isEmptyObj(obj) {
      return isEmpty(obj)
    },

    statusBadge(status) {
      return status === 'valid'
        ? 'success'
        : status === 'pending approval'
        ? 'warning'
        : status === 'rejected'
        ? 'danger'
        : 'secondary'
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .b-table {
  & > tbody {
    & > tr:not(:hover) {
      & .show-when-hovered {
        display: none;
      }
    }

    & > tr:hover {
      & .show-when-hovered {
        display: flex;
      }
    }
  }
}

/deep/ .recent-req-file-action-col {
  width: 3vw !important;
}

@media (pointer: fine) {
  /deep/ .b-table {
    & > tbody {
      & > tr:not(:hover) {
        & .show-when-hovered {
          display: none;
          // visibility: hidden;
        }
      }

      & > tr:hover {
        & .show-when-hovered {
          display: inherit;
          // visibility: visible;
        }
      }
    }
  }
}
</style>
